module.exports = __webpack_public_path__ + "static/media/HPNM01.6c8b0b70.jpg";